import { Component, EventEmitter, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup, UntypedFormControl } from '@angular/forms';
import { createDateAsUTC } from '@core-lib/functions';
import {
	IConfirmModalConfig,
	IGenerationStatementModalDto,
	IGenerationStatementModalForm,
	IReleveOperationsRequestDto
} from '@core-lib/models';
import { AffaireSharedService } from '@core-lib/services';
import { ConfirmationService } from '@core-lib/services/confirmation-service.service';
import { ModalRef } from '@core-lib/modules/modal-container';
import { first } from 'rxjs/operators';

@Component({
	selector: 'generation-statement-modal',
	templateUrl: './generation-statement-modal.component.html',
	standalone: false
})
export class GenerationStatementModalComponent implements OnInit {
	form: FormGroup<IGenerationStatementModalForm>;

	@Input() set affaireIds(value: string[]) {
		if (value) {
			this.form.addControl('affaireIds', new UntypedFormControl(value));
		}
	}

	@Input() toutesAffaires: boolean = false;
	@Input() filterModel: any;
	@Input() confirmStatusEmitter: EventEmitter<boolean>;

	constructor(
		public modalRef: ModalRef,
		private affaireSharedService: AffaireSharedService,
		private confirmationService: ConfirmationService
	) {}

	ngOnInit(): void {
		this.initForm();
	}

	initForm(): void {
		this.form = new FormGroup<IGenerationStatementModalForm>({
			fromDate: new FormControl<Date | null>(null),
			toDate: new FormControl<Date | null>(null),
			hasLogo: new FormControl<boolean | null>(false)
		});
	}

	onConfirm(): void {
		const req = this.mapFormValueToOperationsRequestDto(this.form.value);
		this.confirmStatusEmitter?.emit(true);
		this.affaireSharedService
			.getOperationReleveOtt(req)
			.pipe(first())
			.subscribe({
				next: resp => {
					let textsKey =
						resp.ott && resp.hasEmptyAffaires ? 'EditionConfirm2' : resp.ott ? 'EditionConfirm' : 'EmptyReleveAffaire';

					this.confirmStatusEmitter?.emit(false);
					const config: IConfirmModalConfig = {
						canClose: false,
						textsKey: textsKey,
						confirmBtnText: 'Actions.Ok',
						modalOptions: {
							class: 'modal-md'
						}
					};
					this.confirmationService.openConfirmationModal(
						config,
						resp.ott
							? () => {
									window.open(this.affaireSharedService.getOperationRelevePdf(resp.ott), '_blank');
								}
							: () => {}
					);
				},
				error: () => {
					const config: IConfirmModalConfig = {
						canClose: false,
						textsKey: 'ReleveAffaireError',
						confirmBtnText: 'Actions.Ok',
						modalOptions: {
							class: 'modal-md'
						}
					};
					this.confirmationService.openConfirmationModal(config);

					this.confirmStatusEmitter?.emit(false);
				}
			});
		this.onClose();
	}

	onClose(): void {
		this.modalRef.hide();
	}

	private mapFormValueToOperationsRequestDto(formValue: IGenerationStatementModalDto): IReleveOperationsRequestDto {
		const req: IReleveOperationsRequestDto = {
			dateOperationDebut: formValue.fromDate != null ? createDateAsUTC(formValue.fromDate) : null,
			dateOperationFin: formValue.toDate != null ? createDateAsUTC(formValue.toDate) : null,
			avecEnteteCarpa: formValue.hasLogo,
			affaireIds: formValue.affaireIds,
			toutesAffaires: this.toutesAffaires,
			filtresAffaires: this.filterModel
		};

		return req;
	}
}
